import { render, staticRenderFns } from "./Devider.vue?vue&type=template&id=31ffa33d&"
import script from "./Devider.vue?vue&type=script&lang=js&"
export * from "./Devider.vue?vue&type=script&lang=js&"
import style0 from "./Devider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports